export default {"src":"/_next/static/media/questionMark.0ded620f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};